import React from "react"
import { IntlProvider } from "react-intl"
import staticMessages from "../i18n-translations.json"
import { defaultLanguage } from "../i18n"

function SimpleLocalize({ children, pageContext }) {
  // const isSSR = typeof window === "undefined"

  // const language =
  //   props.pageContext?.language ||
  //   (!isSSR && getCurrentPageLanguage(window.location.pathname)) ||
  //   "en"
  // Normalize: pageContext.language may arrive in UPPERCASE from WordPress ACF
  // (e.g. "GR", "HU", "EN"). Internal keys + i18n-translations.json use lowercase.
  const rawLanguage = pageContext?.language || defaultLanguage
  const language = String(rawLanguage).toLowerCase()
  const messages = pageContext.messages || staticMessages[language]

  // Some internal language keys are not valid ISO 639-1 codes
  // (e.g. "gr" → Greek's actual ISO code is "el"). Map for Intl.NumberFormat
  // and other built-in formatters which require valid BCP 47 locale tags.
  const LOCALE_ALIAS = { gr: "el" }
  const intlLocale = LOCALE_ALIAS[language] || language

  return (
    <IntlProvider locale={intlLocale} messages={messages} defaultLocale="en">
      {children}
    </IntlProvider>
  )
}

export default SimpleLocalize
